import { offerings, steps, email, emailText, headshot, tagline, belief, about, contact, socials, year } from "./content";
import Switcher from "./Switcher";
import "./haiku.css";

const kanji = ["一", "二", "三", "四", "五"];

function Enso() {
  return (
    <svg className="d5-enso" viewBox="0 0 400 400" aria-hidden="true" focusable="false">
      <circle cx="200" cy="200" r="150" fill="none" stroke="currentColor" strokeWidth="22" strokeLinecap="round" strokeDasharray="850 200" transform="rotate(-70 200 200)" opacity=".92" />
      <circle cx="204" cy="197" r="152" fill="none" stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeDasharray="700 400" transform="rotate(-55 200 200)" opacity=".55" />
    </svg>
  );
}

function Seal({ children }) {
  return <span className="d5-seal" aria-hidden="true">{children}</span>;
}

export default function Haiku() {
  return (
    <div className="d5" id="top">
      <a className="d5-skip" href="#main">Skip to content</a>

      <header className="d5-header">
        <a className="d5-brand" href="#top" aria-label="Bit Haiku home">bit haiku</a>
        <nav aria-label="Main navigation">
          <a href="#services">Services</a>
          <a href="#about">About</a>
          <a href="#contact">Contact</a>
        </nav>
      </header>

      <main id="main">
        <section className="d5-hero" aria-labelledby="d5-hero-title">
          <span className="d5-side" aria-hidden="true">software · ai automation · security</span>
          <Enso />
          <h1 id="d5-hero-title">
            <span>More business.</span>
            <span>Less busywork.</span>
            <span>Software that stays out of the way.</span>
          </h1>
          <p className="d5-lead">{tagline}</p>
          <a className="d5-cta" href="#contact">Begin with a conversation</a>
        </section>

        <section className="d5-steps" aria-labelledby="d5-steps-title">
          <h2 id="d5-steps-title" className="d5-small-title">How a project goes</h2>
          <ol>
            {steps.map((step, i) => (
              <li key={step.id}>
                <span className="d5-kanji" aria-hidden="true">{kanji[i]}</span>
                <span className="d5-label">{step.label}</span>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </li>
            ))}
          </ol>
        </section>

        <section className="d5-services" id="services" aria-labelledby="d5-services-title">
          <span className="d5-side" aria-hidden="true">what we do</span>
          <h2 id="d5-services-title">Remove the pain<br />from your processes.</h2>
          <div className="d5-stanzas">
            {offerings.map((offering, i) => (
              <article key={offering.id} className="d5-stanza">
                <span className="d5-kanji" aria-hidden="true">{kanji[i]}</span>
                <h3>{offering.title}</h3>
                <p>{offering.text}</p>
                <p className="d5-items">{offering.items.join(" ・ ")}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="d5-belief" aria-labelledby="d5-belief-title">
          <h2 id="d5-belief-title">{belief.title}</h2>
          <div className="d5-belief-body">
            {belief.paragraphs.map((text) => <p key={text}>{text}</p>)}
          </div>
        </section>

        <section className="d5-about" id="about" aria-labelledby="d5-about-title">
          <figure>
            <img src={headshot} alt={about.alt} width="320" height="320" loading="lazy" />
            <Seal>bit haiku</Seal>
            <figcaption>{about.name}, {about.role}</figcaption>
          </figure>
          <div>
            <span className="d5-label">Who you’ll work with</span>
            <h2 id="d5-about-title">{about.title}</h2>
            {about.paragraphs.map((text) => <p key={text}>{text}</p>)}
            <a className="d5-inline" href="#contact">{about.cta}</a>
          </div>
        </section>

        <section className="d5-contact" id="contact" aria-labelledby="d5-contact-title">
          <span className="d5-side" aria-hidden="true">get in touch</span>
          <h2 id="d5-contact-title">What would simplicity feel like?</h2>
          <p>{contact.lines.map((line) => <span key={line}>{line}<br /></span>)}</p>
          <a className="d5-email" href={email}>{emailText}</a>
        </section>
      </main>

      <footer className="d5-footer">
        <span>© {year} Bit Haiku LLC</span>
        <div>{socials.map((s) => <a key={s.label} href={s.href} target="_blank" rel="noreferrer">{s.label}</a>)}</div>
      </footer>
      <Switcher current={5} />
    </div>
  );
}
